const React = require('react')
const { useHistory, useLocation } = require('react-router-dom')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/verifyContract/index.css')

const VerifiedContract = () => {
    const history = useHistory()
    const { network } = useNetworkConfig()

    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const contractAddress = params.get('a')

    return (
        <div className='box table-section'>
            The Contract Source code for&nbsp;
            <span
                className={`${network.name}-text-color cursor-pointer`}
                onClick={() => history.push(`/${network.name}/address/${contractAddress}#code`)}
            >
                {contractAddress}
            </span>
            &nbsp;has already been verified.
        </div>
    )
}

module.exports = { VerifiedContract }
